import {isMobile, declension} from 'methods/utils';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import EventEmitter from 'methods/eventEmitter';
import Layout from 'components/layout';

function PeoplePicker($element, options = {}) {
    // ссылка на экземпляр
    if ($element._peoplepicker) {
        return $element._peoplepicker;
    }
    $element._peoplepicker = this;

    // наследуемся
    EventEmitter.call(this, options.on);

    this.options = Object.assign({}, {
        adultsMin: 1,
        adultsMax: 20,
        childrensMin: 0,
        childrensMax: 8,
        peoplePosition: 'default',
        isMobile: isMobile(),
        onChange: function() {},
        formInputClass: 'Form-input',
        withPets: false,
        peopleSelected: sessionStorage.getItem('peopleSelected') ? true : false,
        closeChildrenAgesAfterPick: true,
        defaultTitle: '',
    }, options);

    // внешние элементы
    this._$element = $element;
    this._$titleTotal = this._$element.querySelector('[data-title="total"]');

    this.init = function() {
        // создаём элемент
        this._initPicker();

        // открытие элемента
        this._$element.addEventListener('click', e => {
            this.toggle();
        });

        Object.defineProperty(this._$element, 'adults', {
            enumerable: true,
            get: this.getAdults.bind(this),
            set: this.setAdults.bind(this),
        });

        Object.defineProperty(this._$element, 'childrens', {
            enumerable: true,
            get: this.getChildrens.bind(this),
        });

        Object.defineProperty(this._$element, 'children_olds', {
            enumerable: true,
            get: this.getChildrenOlds.bind(this),
            set: this.setChildrenOlds.bind(this),
        });

        // значения по умолчанию
        this.setAdults(2);
        this.setChildrenOlds([]);

        // прокрутка для выбранных возрастов
        this._childrensItemSimpleBar = new SimpleBar(this._$childrensItemContainer, {
            autoHide: false,
        });

        this._$childrensItemContainer = this._$childrensItemContainer.querySelector('.simplebar-content');

        this._initialized = true;
    }

    /**
     * Открытие/закрытие элемента
     */
    this.toggle = function() {
        if (this._$picker.classList.contains('is-opened')) {
            this.close();
        } else {
            this.open();
        }
    }

    /**
     * Открытие элемента
     */
    this.open = function() {
        this._changed = false;
        this._$picker.classList.add('is-opened');

        if (this._$picker.classList.contains('is-opened') && !this._outsideClickBind) {
            document.addEventListener('click', this._outsideClickBind = this._outsideClick.bind(this));
        }

        // скрытие/показ шапки сайта на мобилке
        if (this.options.isMobile) {
            const $documentHeader = document.querySelector('.js-header');
            if ($documentHeader) {
                $documentHeader.classList.toggle('is-hidden', true);
            }

            Layout.scroll.disable('peoplepicker');

            // манипуляции с историей браузера
            window.history.pushState({
                peoplepicker: true,
            }, 'Выбор гостей');
            this._onPopStateEventBind = this._onPopStateEvent.bind(this);
            window.addEventListener('popstate', this._onPopStateEventBind);
        }
    }

    /**
     * Закрытие элемента
     */
    this.close = function(force = false) {
        this._$picker.classList.remove('is-opened');
        this.closeChildrenAges();

        if (this._outsideClickBind) {
            document.removeEventListener('click', this._outsideClickBind);
            delete this._outsideClickBind;
        }

        // скрытие/показ шапки сайта на мобилке
        if (this.options.isMobile) {
            const $documentHeader = document.querySelector('.js-header');
            if ($documentHeader) {
                $documentHeader.classList.toggle('is-hidden', false);
            }

            Layout.scroll.enable('peoplepicker');

            // манипуляции с историей браузера
            window.removeEventListener('popstate', this._onPopStateEventBind);
        }

        this.emit('hide');

        this.confirm(force);
    }

    /**
     * Подтверждение выбранных гостей
     */
    this.confirm = function(force = false) {
        if (!this._changed && !force) {
            return;
        }

        this._$element.dispatchEvent(new Event('change', {
            bubbles: true,
            cancelable: true,
        }));
        this._changed = false;

        this.updateTitleTotal();
        this.emit('confirm');
    }

    /**
     * Возвращает количество взрослых
     * @return {Number}
     */
    this.getAdults = function() {
        return this._adults;
    }

    /**
     * Возвращает количество взрослых
     * @return {Number}
     */
    this.getFilledAdults = function() {
        // ничего не выбрано
        if (this._$titleTotal.classList.contains(this.options.formInputClass + '--muted')) {
            return 0;
        }

        return this._adults;
    }

    /**
     * Устанавливает количество взрослых
     * @param {Number} value
     */
    this.setAdults = function(value) {
        value = Math.max(0, parseInt(value, 10) || 0);

        const increasing = value > this._adults;
        this._adults = value;

        // обновление количества взрослых
        this._updateInputValue(this._$adultsInput, this._adults);

        this._$adultsItemValue.classList.toggle('is-increasing', false);
        this._$adultsItemValue.classList.toggle('is-decreasing', false);
        this._$adultsItemTitle.classList.toggle('is-increasing', false);
        this._$adultsItemTitle.classList.toggle('is-decreasing', false);

        setTimeout(() => {
            this._$adultsItemValue.textContent = this._adults;
            this._$adultsItemValue.classList.toggle(increasing ? 'is-increasing' : 'is-decreasing', true);
        }, 10);

        const title = declension(this._adults, 'Взрослый', 'Взрослых', 'Взрослых');
        if (this._$adultsItemTitle.textContent != title) {
            setTimeout(() => {
                this._$adultsItemTitle.textContent = title;
                this._$adultsItemTitle.classList.toggle(increasing ? 'is-increasing' : 'is-decreasing', true);
            }, 10);
        }
    }

    /**
     * Возвращает количество детей
     * @return {Number}
     */
    this.getChildrens = function() {
        return this._$childrensItems.length;
    }

    /**
     * Установка количества детей
     * @param {Array} value Массив возрастов детей
     */
    this.setChildrenOlds = function(value) {
        while (this._$childrensItemContainer.lastElementChild) {
            this._$childrensItemContainer.removeChild(this._$childrensItemContainer.lastElementChild);
        }

        if (Array.isArray(value)) {
            value.forEach(this.addChildren.bind(this));
        }

        // обновление количества детей
        this._updateInputValue(this._$childrensInput, this._$childrensItems.length);
    }

    /**
     * Установка флага с животными
     * @param {Boolean} value
     */
    this.withPets = function(value) {
        if (!this._$petsButton || !this._$petsInput) {
            return;
        }

        this._$petsButton.classList.toggle('is-active', value);

        this._$petsInput.value = this._$petsButton.classList.contains('is-active') ? 1 : 0;
    }

    this.getWithPets = function() {
        if (!this._$petsInput) {
            return 0;
        }

        return parseInt(this._$petsInput.value, 10);
    }

    /**
     * Обновление значения поля формы с событием
     * @param  {Element} $input      Элемент формы
     * @param  {String|Number} value Значение для записи
     */
    this._updateInputValue = function($input, value) {
        this._changed = true;
        $input.value = value;

        // блок кнопок добавления взрослых
        this._$adultsDecrease.classList.toggle('is-disabled', this.getAdults() <= this.options.adultsMin);
        this._$adultsIncrease.classList.toggle('is-disabled', this.getAdults() >= this.options.adultsMax);

        // скрываем кнопку, если достигнут лимит
        const hideChildrensAdd = this.getChildrens() >= this.options.childrensMax;
        this._$childrensAdd.classList.toggle('is-hidden', hideChildrensAdd);

        this.updateTitleTotal();
    }

    /**
     * Возвращает возраста детей
     * @return {Array}
     */
    this.getChildrenOlds = function() {
        return [...this._$childrensItems].map(function ($item) {
            return parseInt($item.dataset.age, 10);
        });
    }

    /**
     * Добавление детей
     * @param {Number} age Возраст
     */
    this.addChildren = function(age) {
        age = parseInt(age, 10);

        const $item = this._$createElement(
            `<div class="Peoplepicker-childrens-item" data-age="${age}">
                <input type="hidden" name="children_olds[]" value="${age}"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                <div class="Peoplepicker-childrens-item-title">Ребёнок: ${age} ${declension(age, 'год', 'года', 'лет')}</div>
                <div class="Peoplepicker-childrens-item-remove"></div>
            </div>`
        );

        // клик по крестику
        $item.querySelector('.Peoplepicker-childrens-item-remove').addEventListener('click', e => {
            e.stopPropagation();

            // анимации
            $item.classList.add('is-removing');
            setTimeout(() => {
                if ($item.parentNode) {
                    // удаление элемента
                    this._$childrensItemContainer.removeChild($item);

                    // обновление количества детей
                    this._updateInputValue(this._$childrensInput, this._$childrensItems.length);
                }
            }, 200);
        });

        this._$childrensItemContainer.appendChild($item);

        // обновление количества детей
        this._updateInputValue(this._$childrensInput, this._$childrensItems.length);
    }

    /**
     * Возвращает true если список выбора возраста открыт
     * @return {Boolean}
     */
    this.openedChildrenAges = function() {
        return this._$childrensAddButton.classList.contains('is-opened');
    }

    /**
     * Открытие / закрытие выбора возраста
     * @param {Boolean} state true для открытия
     */
    this._toggleChildrenAgesOpenState = function(state) {
        this._$childrensAddButton.classList.toggle('is-opened', state);
        this._$childrensAddItemContainer.classList.toggle('is-opened', state);
    }

    /**
     * Открыть списка выбора возраста
     */
    this.openChildrenAges = function() {
        this._toggleChildrenAgesOpenState(true);
    }

    /**
     * Закрыть список выбора возраста
     */
    this.closeChildrenAges = function() {
        this._toggleChildrenAgesOpenState(false);
    }

    /**
     * Клик вне элемента
     */
    this._outsideClick = function(e) {
        if (this._$element != e.target && !this._$element.contains(e.target)) {
            this.close();
        }
    }

    /**
     * Safe метод вызова callback
     * @param  {Function} f Вызываемая функция
     */
    this._callback = function(f) {
        if (typeof f == 'function') {
            return f.apply(this, [].slice.call(arguments, 1));
        }
    }

    /**
     * Создание элемента пикера
     * @return {Element} HTML Элемент
     */
    this._initPicker = function() {
        const defaultHTML = `
            <div class="Peoplepicker${this.options.isMobile ? ' is-mobile' : ''}${this.options.peoplePosition === 'right' ? ' right' : ''}">
                <div class="Peoplepicker-wrapper">
                    ${this.options.isMobile ?
                        `<div class="Peoplepicker-header">
                            <div class="Peoplepicker-header-close">
                                <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M24 8L2 8M2 8L8.5 14.5M2 8L8.5 1.5" stroke="currentColor" stroke-width="2"/>
                                </svg>
                            </div>
                            <div class="Peoplepicker-header-title">Количество гостей</div>
                        </div>` : ''
                    }
                    <div class="Peoplepicker-container">
                        <div class="Peoplepicker-adults">
                            <input type="hidden" name="adults" value="1"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                            <div class="Peoplepicker-adults-decrease">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 11.25C13.2063 11.25 12.4142 11.25 12 11.25C11.5858 11.25 11.5352 11.25 11.0234 11.25L11.25 11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H11.25L11.3935 12.75C11.9531 12.75 11.5858 12.75 12 12.75C12.4142 12.75 11.9414 12.75 12.5 12.75L12.75 12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H12.75Z" fill="currentColor"/>
                                </svg>
                            </div>
                            <div class="Peoplepicker-adults-item">
                                <span class="Peoplepicker-adults-item-value">1</span><span class="Peoplepicker-adults-item-title">Взрослый</span>
                            </div>
                            <div class="Peoplepicker-adults-increase">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V11.25H5C4.58579 11.25 4.25 11.5858 4.25 12C4.25 12.4142 4.58579 12.75 5 12.75H11.25V19C11.25 19.4142 11.5858 19.75 12 19.75C12.4142 19.75 12.75 19.4142 12.75 19V12.75H19C19.4142 12.75 19.75 12.4142 19.75 12C19.75 11.5858 19.4142 11.25 19 11.25H12.75V5Z" fill="currentColor"/>
                                </svg>
                            </div>
                        </div>
                        <div class="Peoplepicker-childrens">
                            <input type="hidden" name="childrens" value="0"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                            <div class="Peoplepicker-childrens-item-container"></div>
                            <div class="Peoplepicker-childrens-add">
                                <div class="Peoplepicker-childrens-add-button">Добавить ребёнка</div>
                                <div class="Peoplepicker-childrens-add-item-container">
                                    ${Array(17).fill(1).map((x, y) => x + y).map(i => {
                                        return `<div class="Peoplepicker-childrens-add-item" data-value="${i}">${i} ${declension(i, 'год', 'года', 'лет')}</div>`
                                    }).join('')}
                                </div>
                            </div>
                        </div>
                        ${this.options.withPets ?
                            `<div class="Peoplepicker-pets-container">
                                <input type="hidden" name="with_pets" value="0"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                                <span>Можно с питомцами</span>
                                <div class="Peoplepicker-pets-checkbox js-petsButton"></div>
                            </div>` : ``
                        }
                        <div class="Peoplepicker-confirm">
                            <div class="Peoplepicker-confirm-button">Применить</div>
                        </div>
                    </div>
                </div>
            </div>`;
        const mainHTML = `
            <div class="Peoplepicker">
                <div class="Peoplepicker-container">
                    <div class="Peoplepicker-adults">
                        <input type="hidden" name="adults" value="1"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                        <div class="Peoplepicker-adults-decrease">
                            <svg width="16" height="2" viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L15 0.999999" stroke="#0089FD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                        <div class="Peoplepicker-adults-item">
                            <span class="Peoplepicker-adults-item-value">1</span><span class="Peoplepicker-adults-item-title">Взрослый</span>
                        </div>
                        <div class="Peoplepicker-adults-increase">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8 1V15" stroke="#0089FD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1 8L15 8" stroke="#0089FD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>
                    <div class="Peoplepicker-childrens">
                        <input type="hidden" name="childrens" value="0"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                        <div class="Peoplepicker-childrens-item-container"></div>
                        <div class="Peoplepicker-childrens-add">
                            <div class="Peoplepicker-childrens-add-button">Добавить ребёнка</div>
                            <div class="Peoplepicker-childrens-add-item-container">
                                ${Array(17).fill(1).map((x, y) => x + y).map(i => {
                                    return `<div class="Peoplepicker-childrens-add-item" data-value="${i}">${i} ${declension(i, 'год', 'года', 'лет')}</div>`
                                }).join('')}
                            </div>
                        </div>
                    </div>
                    ${this.options.withPets ?
                        `<div class="Peoplepicker-pets-container">
                            <input type="hidden" name="with_pets" value="0"${this.options.formId ? ' form="' + this.options.formId + '"' : ''}>
                            <span>Можно с питомцами</span>
                            <div class="Peoplepicker-pets-checkbox js-petsButton"></div>
                        </div>` : ``
                    }
                </div>
            </div>`;

        this._$picker = this._$createElement(options.main ? mainHTML : defaultHTML);

        this._$adults = this._$picker.querySelector('.Peoplepicker-adults');
        this._$adultsItem = this._$picker.querySelector('.Peoplepicker-adults-item');
        this._$adultsInput = this._$picker.querySelector('input[name="adults"]');
        this._$adultsItemValue = this._$picker.querySelector('.Peoplepicker-adults-item-value');
        this._$adultsItemTitle = this._$picker.querySelector('.Peoplepicker-adults-item-title');
        this._$adultsDecrease = this._$picker.querySelector('.Peoplepicker-adults-decrease');
        this._$adultsIncrease = this._$picker.querySelector('.Peoplepicker-adults-increase');
        this._$childrens = this._$picker.querySelector('Peoplepicker-childrens');
        this._$childrensItems = this._$picker.getElementsByClassName('Peoplepicker-childrens-item');
        this._$childrensInput = this._$picker.querySelector('input[name="childrens"]');
        this._$childrensItemContainer = this._$picker.querySelector('.Peoplepicker-childrens-item-container');
        this._$childrensAdd = this._$picker.querySelector('.Peoplepicker-childrens-add');
        this._$childrensAddButton = this._$picker.querySelector('.Peoplepicker-childrens-add-button');
        this._$childrensAddItemContainer = this._$picker.querySelector('.Peoplepicker-childrens-add-item-container');
        this._$confirmButton = this._$picker.querySelector('.Peoplepicker-confirm-button');
        this._$petsButton = this._$picker.querySelector('.js-petsButton');
        this._$petsInput = this._$picker.querySelector('input[name="with_pets"]');

        const _onConfirmClickEventBind = this._onConfirmClickEvent.bind(this);

        // мобилка
        this._$header = this._$picker.querySelector('.Peoplepicker-header');
        if (this._$header) {
            this._$headerClose = this._$header.querySelector('.Peoplepicker-header-close');
            if (this._$headerClose) {
                this._$headerClose.addEventListener('click', _onConfirmClickEventBind);
            }
        }

        // клик по кнопке подтверждения
        if (!options.main) {
            this._$confirmButton.addEventListener('click', _onConfirmClickEventBind);
        }

        // прокрутка для возрастов
        this._simpleBar = new SimpleBar(this._$childrensAddItemContainer, {
            autoHide: false,
        });

        // открытие/закрытие списка возрастов детей
        this._$childrensAddButton.addEventListener('click', e => {
            e.stopPropagation();
            if (this.openedChildrenAges()) {
                this.closeChildrenAges();
            } else {
                this.openChildrenAges();
            }
        });

        // клик по возрасту для добавления
        const $items = this._$picker.querySelectorAll('.Peoplepicker-childrens-add-item');
        if ($items && $items.length) {
            $items.forEach($item => {
                $item.addEventListener('click', e => {
                    e.stopPropagation();
                    this.addChildren($item.dataset.value);

                    if (this.options.closeChildrenAgesAfterPick) {
                        this.closeChildrenAges();
                    }
                });
            });
        }

        // клики не выходят из пикера
        this._$picker.addEventListener('click', e => {
            e.stopPropagation();
        });

        // клик по минусу
        this._$adultsDecrease.addEventListener('click', e => {
            e.stopPropagation();
            this.setAdults(this.getAdults() - 1);
        });

        // клик по плюсу
        this._$adultsIncrease.addEventListener('click', e => {
            e.stopPropagation();
            this.setAdults(this.getAdults() + 1);
        });

        // для CSS анимаций
        this._$picker.classList.add('is-initialized');

        // добавляем в контейнер
        this._$element.appendChild(this._$picker);

        // клик по чекбоку "с питомцами"
        if (this._$petsButton && this._$petsInput) {
            this._$petsButton.addEventListener('click', () => {
                this._$petsButton.classList.toggle('is-active');

                this._$petsInput.value = this._$petsButton.classList.contains('is-active') ? 1 : 0;

                this.emit('withPets', {
                    value: Number(this._$petsInput.value),
                });
            });
        }

        return this._$picker;
    }

    /**
     * Событие клика на кнопку подтверждения
     * @param {Event} e DOM Событие
     */
    this._onConfirmClickEvent = function(e) {
        e.stopPropagation();
        this.close(true);
    }

    /**
     * Событие нажатия кнопки "назад" в браузере
     * @param {Event} e DOM Событие
     */
    this._onPopStateEvent = function(e) {
        this.close();
    }

    /**
     * Создание элемента
     * @param  {String} html   HTML валидный текст
     * @return {Element|Array} Элемент или массив элементов
     */
    this._$createElement = function(html) {
        const $template = document.createElement('template');
        $template.insertAdjacentHTML('afterbegin', html);
        return $template.children.length > 1 ? Array.from($template.children) : $template.children[0];
    }

    /**
     * Возвращаем выбранные кол-во человек
     */
    this.getSearchTitle = function() {
        return this.getAdults() + this.getChildrens();
    }

    /**
     * Возвращаем выбранные кол-во человек
     */
    this.getSearchTitleFull = function() {
        let count = this.getAdults() + this.getChildrens();

        return count + ' ' + declension(count, 'гость', 'гостя', 'гостей');
    }

    /**
     * Возвращаем выбранные даты в формате 07 июл - 20 июл
     */
    this.getSearchFields = function() {
        return {
            adults: this.getAdults(),
            childrens: this.getChildrens(),
        };
    }

    /**
     * Делает this.open() если пользователь не вводил кол-во гостей
     */
    // this.canOpenAfterDate = function() {
    //     if (this.options.peopleSelected) {
    //         return false;
    //     }

    //     this.options.peopleSelected = true;
    //     sessionStorage.setItem('peopleSelected', true);
    //     this.open();

    //     return true;
    // }

    /**
     * Сброс значений
     */
    this.reset = function(options) {
        this.setAdults(options ? options.adults : 2);
        this.setChildrenOlds([]);

        if (options && options.petReset) this.withPets(false);
    }

    /**
     * Обновление итогового количества
     */
    this.updateTitleTotal = function() {
        if (!this._initialized || options.main) {
            return;
        }

        // значение по умолчанию
        const total = this.getAdults() + this.getChildrens();
        if (total == 0 && this.options.defaultTitle) {
            this._$titleTotal.textContent = this.options.defaultTitle;
            this._$titleTotal.classList.add(this.options.formInputClass + '--muted');
            return;
        }

        // нужен свой формат
        if (this.options.customTitleFormatter) {
            this._$titleTotal.textContent = this.options.customTitleFormatter(this.getAdults(), this.getChildrens());
            this._$titleTotal.classList.remove(this.options.formInputClass + '--muted');
            return;
        }

        // формат по умолчанию
        this._$titleTotal.textContent = total + ' ' + declension(total, 'гость', 'гостя', 'гостей');
        this._$titleTotal.classList.remove(this.options.formInputClass + '--muted');
    }

    this.init();
}

// цепочка прототипов
PeoplePicker.prototype = Object.create(EventEmitter.prototype, {
    constructor: {
        value: PeoplePicker,
        enumerable: false,
        writable: true,
    }
});

export default PeoplePicker;
